var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 333,
    viewBox: "0 0 309 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2535_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.151 315.681C243.187 315.681 309.69 307.324 309.69 297.016C309.69 286.707 243.187 278.35 161.151 278.35C79.1154 278.35 12.6123 286.707 12.6123 297.016C12.6123 307.324 79.1154 315.681 161.151 315.681Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0967 197.742V195.933H45.6115V197.742H77.0967Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.82 171.839H46.1611V206.18H47.82V171.839Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.168 198.647H58.5861V292.926C58.5861 293.565 58.3533 294.178 57.939 294.63C57.5248 295.081 56.9629 295.335 56.377 295.335C55.7911 295.335 55.2293 295.081 54.815 294.63C54.4007 294.178 54.168 293.565 54.168 292.926V198.647Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.299 198.647H141.717V292.926C141.717 293.242 141.66 293.556 141.549 293.848C141.438 294.14 141.275 294.406 141.07 294.63C140.865 294.853 140.621 295.031 140.353 295.152C140.085 295.273 139.798 295.335 139.508 295.335C139.218 295.335 138.931 295.273 138.663 295.152C138.395 295.031 138.151 294.853 137.946 294.63C137.741 294.406 137.578 294.14 137.467 293.848C137.356 293.556 137.299 293.242 137.299 292.926V198.647Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1064 201.352H139.788V261.577C139.788 263.598 139.423 265.599 138.714 267.466C138.005 269.333 136.965 271.029 135.655 272.458C134.345 273.887 132.79 275.021 131.078 275.794C129.366 276.567 127.531 276.965 125.679 276.965H70.2071C66.4666 276.963 62.88 275.341 60.2359 272.455C57.5918 269.569 56.1064 265.657 56.1064 261.577V201.352Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2219 159.488L44.5026 179.363H33.8129C33.3601 179.351 32.9295 179.146 32.6133 178.793C32.297 178.439 32.12 177.965 32.1201 177.471V171.821C32.1205 170.388 32.4978 168.985 33.2075 167.779C33.9171 166.573 34.9292 165.615 36.1235 165.018L55.8017 155.195C57.3026 154.447 58.9335 154.06 60.5837 154.06C61.8244 154.062 63.0136 154.601 63.8908 155.558C64.7681 156.515 65.262 157.812 65.2642 159.165L65.2219 159.488Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.735 197.742V195.933H122.25V197.742H153.735Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.518 206.17H153.177V171.83H151.518V206.17Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.125 159.488L153.989 178.551C154.536 179.077 155.241 179.366 155.97 179.363H164.264C165.059 179.363 165.821 179.019 166.383 178.406C166.945 177.793 167.261 176.962 167.261 176.095V171.821C167.262 170.388 166.886 168.984 166.176 167.777C165.466 166.571 164.453 165.613 163.257 165.018L143.579 155.195C142.078 154.447 140.447 154.06 138.797 154.06C137.557 154.063 136.369 154.601 135.493 155.559C134.617 156.516 134.125 157.813 134.125 159.165V159.488Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7717 169.125L53.1437 189.351C52.5167 190.36 52.1243 191.52 52.0004 192.731C51.8766 193.942 52.0249 195.168 52.4328 196.302C52.9389 197.704 53.8197 198.906 54.9609 199.754C56.102 200.602 57.4506 201.056 58.8314 201.056H136.453C137.949 201.053 139.423 200.656 140.749 199.899C142.075 199.142 143.214 198.048 144.07 196.709C144.988 195.276 145.554 193.611 145.713 191.871C145.871 190.132 145.618 188.377 144.976 186.776L135.031 170.03L65.7717 169.125Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4074 53.458H127.625C129.982 53.458 132.242 54.4792 133.909 56.297C135.576 58.1147 136.512 60.5801 136.512 63.1508V182.382H63.5205V63.1508C63.5205 60.5801 64.4568 58.1147 66.1234 56.297C67.7901 54.4792 70.0505 53.458 72.4074 53.458Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1628 115.686L55.2512 132.043C55.2512 132.043 36.631 153.524 35.5561 156.211C34.4812 158.897 32.873 175.246 32.873 176.52C32.873 177.793 36.9018 181.135 36.9018 181.135L40.4481 182.575L42.6825 181.107C42.6825 181.107 42.6825 175.984 43.1311 174.756C43.7832 173.392 44.5331 172.087 45.374 170.852C45.374 170.852 44.6969 176.713 45.5941 176.713C46.4912 176.713 47.3884 171.101 47.3884 167.436C47.3884 163.771 43.6136 157.402 43.6136 157.402C43.6136 157.402 61.2944 152.278 63.5373 148.613C65.7801 144.949 72.2634 121.76 72.2634 121.76L58.1628 115.686Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2516 132.043C55.2516 132.043 54.3629 137.167 56.5973 138.875C58.8318 140.582 60.6261 138.145 60.6261 138.145",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.151 169.402C41.151 169.402 39.6021 177.932 40.2538 178.634C40.9055 179.335 41.5996 182.049 41.5996 182.049",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4678 168.655C38.4678 168.655 37.3506 176.714 37.3506 178.181C37.3506 179.649 39.365 182.086 39.365 182.086",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3707 169.144C35.3707 169.144 34.6936 175.246 34.9221 176.714C35.1506 178.181 36.9365 181.108 36.9365 181.108",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.318 86.875C129.318 86.875 134.913 103.962 138.044 112.51C141.176 121.058 151.502 149.094 151.273 151.863C151.045 154.633 139.856 154.549 137.401 152.352C134.947 150.155 120.854 119.831 120.854 119.831L129.318 86.875Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4529 80.7824L67.1179 86.8843L52.1201 117.144L72.4924 126.422L74.9469 122.517L76.5211 137.407C76.5211 137.407 61.9719 164.261 59.9576 173.787C57.9432 183.314 63.5377 194.539 70.478 197.706C77.4183 200.872 120.837 198.195 126.432 196.736C132.026 195.278 137.435 185.013 136.952 177.203C136.47 169.393 129.784 151.568 129.115 149.86C128.446 148.152 121.057 134.73 121.057 134.73L122.852 121.058L126.88 84.678L108.751 78.5762L89.0475 78.8254L83.4529 80.7824Z",
    fill: "#455A64",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.057 134.73L122.852 121.058L126.881 84.678L108.751 78.5762L89.0475 78.8254L83.453 80.7824L67.1179 86.8843L52.1201 117.144L72.4924 126.422L74.9469 122.517L76.5211 137.407C76.5211 137.407 68.5144 152.177 63.5547 163.707H91.1804C106.415 163.707 124.045 162.498 131.806 164.002C132.653 164.169 133.415 164.325 134.159 164.492C132.069 157.577 129.538 150.875 129.14 149.86C128.472 148.171 121.057 134.73 121.057 134.73Z",
    fill: "#F5F5F5",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1736 281.175C83.1736 281.175 81.2354 286.898 77.926 290.212C74.6167 293.526 71.0196 299.25 72.6785 301.964C74.3374 304.678 82.0648 303.81 85.1033 301.659C88.1418 299.508 88.4211 296.24 91.4511 294.736C94.4812 293.231 96.6987 289.917 95.5984 284.793C94.4981 279.67 83.1736 281.175 83.1736 281.175Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8779 287.092C94.0159 289.289 90.3849 293.203 88.6922 294.127C86.4831 295.336 85.933 302.259 80.1353 302.259C77.4347 302.221 74.7657 301.62 72.2725 300.487C72.2856 301.001 72.426 301.502 72.6787 301.936C74.3715 304.65 82.065 303.782 85.1035 301.632C88.142 299.481 88.4213 296.213 91.4513 294.708C92.8169 294.088 93.9742 293.024 94.7662 291.662C95.5582 290.299 95.9463 288.704 95.8779 287.092Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.058 187.2C74.058 187.2 73.5079 218.227 77.0965 233.883C80.6851 249.539 82.6149 276.347 82.6149 276.347L81.7685 279.965L82.3271 284.184C84.2579 285.568 86.2905 286.775 88.4041 287.793C92.5429 289.907 96.9609 285.689 96.9609 285.689C96.9609 285.689 95.5813 271.842 95.2682 270.919C94.955 269.996 98.3067 213.685 98.3067 208.266C98.3067 202.847 99.4154 189.887 98.8653 182.963C98.3151 176.04 89.5382 164.307 79.5764 163.402C69.6145 162.497 62.4542 169.725 62.7335 179.972",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.058 187.2C74.058 187.2 73.5079 218.227 77.0965 233.883C80.6851 249.539 82.6149 276.347 82.6149 276.347L81.7685 279.965L82.3271 284.184C84.2579 285.568 86.2905 286.775 88.4041 287.793C92.5429 289.907 96.9609 285.689 96.9609 285.689C96.9609 285.689 95.5813 271.842 95.2682 270.919C94.955 269.996 98.3067 213.685 98.3067 208.266C98.3067 202.847 99.4154 189.887 98.8653 182.963C98.3151 176.04 89.5382 164.307 79.5764 163.402C69.6145 162.497 62.4542 169.725 62.7335 179.972",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.182 281.175C116.182 281.175 118.112 286.898 121.43 290.212C124.747 293.526 128.336 299.25 126.677 301.964C125.018 304.678 117.282 303.81 114.244 301.659C111.205 299.508 110.935 296.24 107.896 294.736C104.858 293.231 102.649 289.917 103.749 284.793C104.849 279.67 116.182 281.175 116.182 281.175Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.478 287.092C105.331 289.289 108.962 293.203 110.655 294.127C112.864 295.336 113.423 302.259 119.22 302.259C121.917 302.23 124.583 301.638 127.075 300.515C127.065 301.028 126.927 301.529 126.677 301.964C124.984 304.678 117.282 303.81 114.244 301.659C111.205 299.508 110.934 296.24 107.896 294.736C106.525 294.116 105.365 293.048 104.574 291.679C103.782 290.311 103.4 288.708 103.478 287.092Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.297 187.2C125.297 187.2 125.847 218.227 122.259 233.883C118.67 249.539 116.732 276.347 116.732 276.347L117.578 279.965L117.028 284.184C115.096 285.565 113.063 286.772 110.951 287.793C106.804 289.907 102.386 285.689 102.386 285.689C102.386 285.689 103.765 271.842 104.079 270.919C104.392 269.996 101.04 213.685 101.04 208.266C101.04 202.847 99.9398 189.887 100.49 182.963C101.04 176.04 109.851 164.307 119.77 163.402C129.69 162.497 136.893 169.725 136.613 179.972",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.297 187.2C125.297 187.2 125.847 218.227 122.259 233.883C118.67 249.539 116.732 276.347 116.732 276.347L117.578 279.965L117.028 284.184C115.096 285.565 113.063 286.772 110.951 287.793C106.804 289.907 102.386 285.689 102.386 285.689C102.386 285.689 103.765 271.842 104.079 270.919C104.392 269.996 101.04 213.685 101.04 208.266C101.04 202.847 99.9398 189.887 100.49 182.963C101.04 176.04 109.851 164.307 119.77 163.402C129.69 162.497 136.893 169.725 136.613 179.972",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.966 141.072L95.09 156.94C95.09 156.94 85.2467 162.313 83.901 162.802C82.5552 163.291 78.9751 168.904 78.5349 169.883C78.0948 170.861 80.1007 171.101 80.9894 170.852C81.8781 170.603 85.6953 169.144 85.6953 169.144C85.6953 169.144 83.4524 170.363 85.6953 170.363C87.9382 170.363 91.2898 167.926 91.2898 167.926C91.2898 167.926 97.7815 165.969 98.4502 164.999C99.1188 164.03 101.582 161.307 101.582 161.307C101.582 161.307 129.783 159.35 134.489 158.38C139.195 157.411 148.141 154.688 149.724 153.248C151.306 151.808 151.738 150.082 149.944 146.417",
    fill: "#B16668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.966 141.072L95.09 156.94C95.09 156.94 85.2467 162.313 83.901 162.802C82.5552 163.291 78.9751 168.904 78.5349 169.883C78.0948 170.861 80.1007 171.101 80.9894 170.852C81.8781 170.603 85.6953 169.144 85.6953 169.144C85.6953 169.144 83.4524 170.363 85.6953 170.363C87.9382 170.363 91.2898 167.926 91.2898 167.926C91.2898 167.926 97.7815 165.969 98.4502 164.999C99.1188 164.03 101.582 161.307 101.582 161.307C101.582 161.307 129.783 159.35 134.489 158.38C139.195 157.411 148.141 154.688 149.724 153.248C151.306 151.808 151.738 150.082 149.944 146.417",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6953 169.144L91.4845 165.128L93.702 163.762",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4238 170.566C79.4238 170.566 79.8386 168.719 80.5326 168.719C81.2266 168.719 85.9409 164.639 85.9409 164.639L91.2054 162.673",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6819 161.5C89.6819 161.5 82.9109 164.214 82.4792 164.824C82.0476 165.433 79.7031 167.999 79.7031 167.999",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9593 58.8027C91.9593 58.8027 91.9593 70.2772 91.5107 77.8468C91.0621 85.4165 94.6508 99.8172 98.451 100.796C102.251 101.774 107.854 83.4594 107.854 81.7517C107.854 80.0439 110.317 68.8279 110.317 68.8279L91.9593 58.8027Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.896 81.2161C108.125 79.1483 109.352 73.3049 109.962 70.434L94.9385 67.3784C96.8766 70.7183 99.1474 73.8142 101.709 76.6097C103.487 78.5565 105.587 80.1193 107.896 81.2161Z",
    fill: "#455A64",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2902 22.9207C91.2902 22.9207 80.2873 31.9489 78.9754 41.4756C77.6635 51.0023 77.6381 83.7087 78.7554 92.0076C79.8726 100.307 87.4815 102.993 89.9444 102.993C92.4074 102.993 95.539 98.5987 95.539 98.5987C95.539 98.5987 90.3846 94.6939 90.3846 88.3428C90.3846 81.9917 91.9503 58.8027 91.9503 58.8027L102.234 36.8323L118.797 43.9126C118.797 43.9126 117.003 60.9997 114.566 65.8831C112.822 69.0416 110.354 71.6504 107.405 73.4527C107.405 73.4527 108.074 84.1887 107.854 89.072C107.739 91.94 106.618 94.6501 104.722 96.6417C104.722 96.6417 109.42 105.873 114.345 101.257C119.271 96.6417 119.491 85.6288 119.491 82.2132C119.491 78.7976 119.711 43.6449 119.711 43.6449C120.698 42.7654 121.477 41.641 121.984 40.3659C122.49 39.0907 122.709 37.7018 122.623 36.3153C122.403 31.432 114.794 24.8408 105.171 22.1545C95.5474 19.4682 91.2902 22.9207 91.2902 22.9207Z",
    fill: "#455A64",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.387 33.4165L92.9236 53.1899C92.9236 53.1899 90.4607 47.5773 88.4463 49.7743C86.4319 51.9713 86.1526 58.0732 88.6071 60.4733L91.0616 62.9196L92.4073 61.9411C92.4073 61.9411 95.3189 70.2492 101.133 73.9417C106.948 77.6343 110.088 77.6343 112.78 74.9203C115.471 72.2063 119.271 64.4151 119.711 59.5317C120.152 54.6484 120.388 44.1525 120.16 42.4447C119.931 40.7369 101.387 33.4165 101.387 33.4165Z",
    fill: "#B16668",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.084 53.2454C116.877 54.8555 113.382 55.669 109.851 55.627C102.886 55.627 95.463 53.0423 93.2539 52.2207L92.8392 53.19L95.0736 54.4085C95.0736 54.4085 96.4194 57.5841 97.088 59.0241C97.7566 60.4642 97.088 67.3323 97.088 67.3323L92.3906 61.9597C92.3906 61.9597 95.3022 70.2678 101.117 73.9603C106.931 77.6528 110.071 77.6528 112.763 74.9388C115.454 72.2248 119.255 64.4337 119.695 59.5503C119.864 57.8887 120.008 55.6178 120.084 53.2454Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.895 52.0823C108.895 53.0054 108.54 53.707 108.1 53.707C107.66 53.707 107.312 52.9777 107.312 52.0823C107.312 51.1868 107.668 50.4668 108.1 50.4668C108.531 50.4668 108.895 51.1868 108.895 52.0823Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.427 53.1718C116.867 53.1718 117.223 52.4444 117.223 51.5471C117.223 50.6498 116.867 49.9224 116.427 49.9224C115.988 49.9224 115.632 50.6498 115.632 51.5471C115.632 52.4444 115.988 53.1718 116.427 53.1718Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.74 47.6515C103.74 47.6515 107.701 45.4913 110.681 47.6515",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.429 54.7871L114.438 48.7314C114.438 48.7314 115.234 44.845 118.408 47.0051",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.872 107.211L171.501 102.088C171.501 102.088 161.709 94.0752 160.278 94.0752H150.477C149.859 94.0752 149.453 96.5307 150.68 99.1986C151.908 101.866 150.883 106.316 153.329 108.097C155.775 109.879 167.616 110.996 167.616 110.996L178.027 116.784L179.872 107.211Z",
    fill: "#DEDEDE",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.278 94.0752H150.477C149.859 94.0752 149.453 96.5307 150.68 99.1985C151.908 101.866 150.883 106.316 153.329 108.097C155.775 109.879 167.616 110.996 167.616 110.996L168.894 111.707C170.03 110.86 170.929 109.687 171.493 108.319C171.92 106.365 172.063 104.349 171.916 102.346L171.493 102.088C171.493 102.088 161.709 94.0752 160.278 94.0752Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.453 97.8537L149.476 95.7031L140.8 100.392L141.777 102.543L150.453 97.8537Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.812 100.399L139.534 102.273L141.794 102.55L140.812 100.399Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.534 102.272L134.438 105.023",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.055 92.4692C150.055 92.4692 146.627 93.0508 146.813 94.3709C146.999 95.6909 147.05 97.4818 148.506 97.4634C149.962 97.4449 150.613 97.7772 150.909 95.4786C151.206 93.18 150.952 92.9954 150.055 92.4692Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.631 98.368C149.631 98.368 147.473 98.368 147.473 99.9188C147.473 101.47 148.082 102.144 149.106 102.144C150.13 102.144 154.616 102.144 154.616 100.362C154.616 98.5803 153.77 98.1372 152.983 98.1372C152.195 98.1372 149.631 98.368 149.631 98.368Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.782 102.18C150.782 102.18 148.624 102.18 148.624 103.731C148.624 105.282 149.233 105.956 150.258 105.956C151.282 105.956 155.767 105.956 155.767 104.174C155.767 102.393 154.921 101.95 154.134 101.95C153.347 101.95 150.782 102.18 150.782 102.18Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.763 105.476C152.763 105.476 150.858 105.476 150.858 106.833C150.858 108.19 151.4 108.79 152.297 108.79C153.194 108.79 157.147 108.79 157.147 107.23C157.147 105.67 156.428 105.273 155.708 105.273C154.989 105.273 152.763 105.476 152.763 105.476Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.462 101.202L161.48 91.4077C161.48 91.4077 154.946 92.7463 153.11 93.1894C151.273 93.6325 150.046 94.5279 151.07 96.0788C152.094 97.6296 157.392 96.5311 157.392 96.5311C157.392 96.5311 160.05 104.544 163.926 104.544",
    fill: "#28CC9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.462 101.202L161.48 91.4077C161.48 91.4077 154.946 92.7463 153.11 93.1894C151.273 93.6325 150.046 94.5279 151.07 96.0788C152.094 97.6296 157.392 96.5311 157.392 96.5311C157.392 96.5311 160.05 104.544 163.926 104.544",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.967 82.5086L191.738 108.993L179.254 105.651L175.175 118.114C175.175 118.114 209.25 133.031 211.501 132.81C213.753 132.588 193.338 80.9485 193.135 78.9361C192.932 76.9237 185.585 76.499 184.967 82.5086Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.96 276.734C190.96 276.734 185.238 281.784 181.709 283.556C178.179 285.329 170.554 288.901 170.274 291.274C169.995 293.646 174.362 293.951 181.709 293.951C189.055 293.951 197.739 295.04 199.914 294.449C202.09 293.858 204.019 293.351 204.019 291.569C204.019 289.787 202.107 280.593 202.107 280.593L190.96 276.734Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.64 291.735C174.87 291.652 171.747 291.116 170.486 290.683C170.38 290.863 170.305 291.063 170.266 291.273C169.995 293.646 174.354 293.95 181.7 293.95C189.047 293.95 197.731 295.04 199.906 294.449C202.081 293.858 204.011 293.35 204.011 291.569C204.003 291.288 203.98 291.007 203.943 290.729C196.871 291.584 189.754 291.92 182.64 291.735Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.664 285.402C236.664 285.402 232.381 289.926 230.307 291.283C228.234 292.64 218.983 297.163 219.812 298.972C220.642 300.782 228.792 302.739 233.075 302.739C237.358 302.739 247.463 299.425 249.376 298.363C250.056 297.925 250.627 297.311 251.037 296.575C251.448 295.839 251.685 295.004 251.729 294.144C251.729 293.544 250.341 288.726 249.655 287.821C248.97 286.916 236.664 285.402 236.664 285.402Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.376 298.363C250.017 297.959 250.562 297.395 250.966 296.718C251.37 296.042 251.623 295.271 251.704 294.468C248.149 296.139 240.024 299.49 232.796 299.72C226.643 299.923 222.639 298.437 220.6 297.394C219.956 298.013 219.626 298.557 219.812 298.973C220.659 300.773 228.792 302.739 233.075 302.739C237.358 302.739 247.447 299.425 249.376 298.363Z",
    fill: "white",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.489 202.838L192.314 266.645L188.505 269.313L188.776 277.621C188.776 277.621 188.776 281.184 194.218 282.966C197.756 284.045 201.454 284.359 205.102 283.889C205.102 283.889 205.652 275.876 206.194 273.494C206.736 271.113 205.652 266.968 206.194 265.482C206.736 263.995 220.337 206.725 220.337 206.725L222.241 197.235L236.393 280.316L233.947 281.802V285.061C233.947 285.061 240.472 290.997 243.469 292.446C246.114 293.587 248.843 294.48 251.628 295.114C251.628 295.114 252.474 287.997 252.719 285.32C252.965 282.642 249.452 275.23 249.452 275.23C249.452 275.23 251.357 229.535 251.628 225.076C251.898 220.618 249.723 204.306 249.723 204.306L234.488 153.534L207.278 150.562L194.489 202.838Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.115 58.9134C182.005 59.6057 182.115 74.7173 182.522 77.1636C182.928 79.6099 192.111 96.5492 192.111 96.5492L204.358 141.062L191.95 205.81L198.891 209.595L214.802 167.085L213.584 214.266C213.584 214.266 232.153 217.608 241.946 216.048C248.829 214.847 255.643 213.211 262.352 211.146C262.352 211.146 266.431 135.034 265.416 130.354C264.4 125.674 249.656 74.4957 236.808 64.7014C223.96 54.907 202.953 47.3374 200.287 46.2389C198.234 45.4745 196.111 44.9515 193.956 44.6788C193.956 44.6788 184.333 44.2264 182.115 58.9134Z",
    fill: "#F5F5F5",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.422 63.1412L194.354 94.0752L195.674 45.5464L193.947 44.6694L187.422 63.1412Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.953 15.4896C189.953 15.4896 189.402 7.41228 191.874 5.61219C194.345 3.81209 195.166 8.00308 195.166 8.00308C195.166 8.00308 197.909 -0.369681 201.201 0.230352C204.493 0.830385 204.493 2.02121 204.493 2.02121C204.493 2.02121 209.978 -1.56975 212.17 0.821153C212.826 1.57824 213.334 2.47245 213.664 3.4498C213.995 4.42716 214.14 5.46736 214.091 6.50761C214.091 6.50761 220.405 5.31678 221.506 8.60311C222.606 11.8894 218.484 16.3851 218.484 16.3851C219.04 17.1328 219.448 17.9973 219.684 18.9249C219.92 19.8524 219.978 20.823 219.855 21.7761C219.584 25.3671 216.013 26.8626 216.013 26.8626C216.013 26.8626 219.855 29.2535 218.213 32.5398C216.571 35.8261 212.999 35.8354 212.999 35.8354C212.999 35.8354 214.371 40.9218 210.249 41.8172C207.702 42.3497 205.078 42.2487 202.572 41.5218L199.83 43.3127L193.516 36.1308L189.953 15.4896Z",
    fill: "#455A64",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.062 22.9851C154.201 29.3086 152.576 37.1367 155.657 42.417C159.5 48.9988 162.513 53.4945 162.792 55.2853C163.071 57.0762 162.513 61.8672 163.884 62.4673C165.255 63.0673 171.298 68.4491 173.49 69.6492C175.682 70.8492 179.525 71.7447 180.896 70.2492C182.267 68.7537 184.739 63.0673 184.739 63.0673L193.541 72.4186L195.183 46.6818L194.616 44.8355C194.616 44.8355 201.201 36.1489 194.616 19.6988C191.552 12.0369 183.291 9.09209 176.148 9.37826C167.337 9.70135 160.922 14.4555 157.062 22.9851Z",
    fill: "#F7A9A0",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.289 58.2765L180.625 50.1992L185.56 39.7217C185.56 39.7217 179.796 48.9529 176.783 51.0946C174.091 52.9409 164.883 57.4365 162.902 58.3965C162.902 60.2428 163.063 62.089 163.884 62.4675C165.255 63.0676 171.298 68.4494 173.491 69.6495C175.683 70.8495 179.525 71.7449 180.896 70.2495C182.267 68.754 184.739 63.0676 184.739 63.0676L189.953 48.4083L185.289 58.2765Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.288 44.7806C185.288 44.7806 184.188 37.5987 186.93 36.694C189.673 35.7894 193.126 41.2635 192.423 45.076C191.408 50.4855 184.882 50.4394 186.66 47.7716",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.288 44.7806C185.288 44.7806 184.188 37.5987 186.93 36.694C189.673 35.7894 193.126 41.2635 192.423 45.076C191.408 50.4855 184.882 50.4394 186.66 47.7715",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.616 44.7804C194.616 44.7804 201.201 36.0937 194.616 19.6436C191.552 11.9817 183.292 9.03691 176.148 9.32308C167.338 9.67387 160.914 14.4187 157.063 22.9484C155.519 26.2544 154.514 29.8277 154.092 33.509C154.498 33.9798 156.36 35.8445 159.5 34.0075C163.063 31.912 166.356 25.3301 170.748 28.321C175.141 31.3119 170.469 40.8848 175.133 40.3217C179.796 39.7586 187.21 38.2262 188.582 39.7216C189.953 41.2171 193.846 45.9989 195.674 45.5466L194.616 44.7804Z",
    fill: "#455A64",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.034 44.8264L185.822 37.9214",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.556 49.5161L172.035 44.8267L173.474 48.0761C173.711 48.6139 173.743 49.2319 173.564 49.7955C173.385 50.3592 173.009 50.8228 172.517 51.0855L166.999 54.0395C166.53 54.2954 165.987 54.3422 165.486 54.1699C164.986 53.9977 164.566 53.6199 164.316 53.1163L162.556 49.5161Z",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.193 54.0763L160.677 50.3838L162.115 53.6332C162.352 54.1696 162.384 54.7863 162.205 55.3484C162.025 55.9106 161.65 56.3725 161.159 56.6333L158.62 57.9257C158.15 58.1817 157.608 58.2285 157.107 58.0562C156.607 57.8839 156.187 57.5061 155.937 57.0026L154.193 54.0763Z",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.677 50.4208L162.556 49.5161",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.43 51.6487L163.106 50.9194",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.108 48.9806L167.955 51.5284C167.955 51.5284 171.188 50.1899 172.305 48.6113",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.324 47.2728C164.324 47.2728 167.329 43.9957 171.231 44.2357",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.036 117.227C158.036 117.227 145.992 111.439 145.34 111.218C144.688 110.996 136.157 106.99 134.93 107.211C133.702 107.433 128.607 112.556 127.583 113.443C126.559 114.329 122.894 119.452 123.503 120.828C124.113 122.203 125.543 120.154 125.543 120.154C125.543 120.154 124.324 122.157 125.746 122.378C127.168 122.6 127.989 120.828 127.989 120.828C127.989 120.828 127.583 122.609 128.836 122.831C130.088 123.052 131.079 121.271 131.079 121.271C131.079 121.271 132.103 122.831 132.915 122.831C133.728 122.831 137.198 118.603 137.198 118.603C137.198 118.603 139.652 121.049 141.692 121.492C143.732 121.935 149.039 120.569 149.039 120.569L158.222 125.683L158.036 117.227Z",
    fill: "#DEDEDE",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.932 119.674C153.278 118.105 153.35 116.48 153.143 114.883C149.758 113.249 145.729 111.347 145.382 111.19C144.773 110.968 136.199 106.962 134.972 107.184C133.744 107.405 128.649 112.529 127.625 113.415C126.601 114.301 122.936 119.424 123.545 120.8C124.155 122.175 125.585 120.126 125.585 120.126C125.585 120.126 124.366 122.129 125.788 122.351C127.21 122.572 128.031 120.8 128.031 120.8C128.031 120.8 127.625 122.581 128.878 122.803C130.13 123.024 131.121 121.243 131.121 121.243C131.121 121.243 132.145 122.803 132.957 122.803C133.77 122.803 137.24 118.575 137.24 118.575C137.24 118.575 139.694 121.021 141.734 121.464C143.774 121.908 149.081 120.541 149.081 120.541L151.924 122.12C152.329 121.34 152.666 120.521 152.932 119.674Z",
    fill: "#28CC9E",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.096 121.234L136.402 114.329",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.031 120.791C128.031 120.791 131.095 115.003 131.916 114.329C132.737 113.655 135.589 111.218 135.589 111.218",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.031 120.791C128.031 120.791 131.095 115.003 131.916 114.329C132.737 113.655 135.589 111.218 135.589 111.218",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.586 120.117L129.665 113.664L133.753 110.553",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.586 120.117L129.665 113.664L133.753 110.553",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.788 64.9229C205.788 64.9229 200.71 68.2646 200.278 73.6002C199.847 78.9359 193.744 123.246 193.744 123.246L157.418 115.861L155.378 133.89C155.378 133.89 206.397 145.244 207.21 143.906C208.023 142.567 223.943 89.598 223.943 89.598",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.788 64.9229C205.788 64.9229 200.71 68.2646 200.278 73.6002C199.847 78.9359 193.744 123.246 193.744 123.246L157.418 115.861L155.378 133.89C155.378 133.89 206.397 145.244 207.21 143.906C208.023 142.567 223.943 89.598 223.943 89.598",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.533 120.117C207.642 119.766 208.768 119.397 209.868 119.009",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.175 123.246C195.175 123.246 199.407 122.277 204.392 120.781",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2535_4068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 332.175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor1);
export default __webpack_public_path__ + "static/media/doctor1.c013417c1877f7024d7e9342f73760d2.svg";
export { ForwardRef as ReactComponent };